class CustomBraceletCube {
    constructor() {
        this.mainContainer = document.querySelector(".bracelet-cubes-container .bracelet-cubes-content");

        this.leftContainer = this.mainContainer?.querySelector(".left-container");
        this.image = this.leftContainer?.querySelector(".image-container img");

        this.rightContainer = this.mainContainer?.querySelector(".right-container");

        this.prevStepBtn = this.mainContainer?.querySelector(".actual-step-container .actual-step-content");
        this.nextStepBtn = this.mainContainer?.querySelector(".next-step-container .continue-container");
        this.closeStepBtn = this.mainContainer?.querySelector(".actual-step-container .close-container");
        this.resetStepBtn = this.mainContainer?.querySelector(".next-step-container .reset-container");

        this.sizeStepBtn = this.mainContainer?.querySelector(".hub-content .size-container");
        this.linkStepBtn = this.mainContainer?.querySelector(".hub-content .link-container");
        this.cubeStepBtn = this.mainContainer?.querySelector(".hub-content .cube-container");

        this.sizeRecap = this.mainContainer?.querySelector(".hub-content .size-recap");
        this.linkRecap = this.mainContainer?.querySelector(".hub-content .link-recap");
        this.cubeRecap = this.mainContainer?.querySelector(".hub-content .cube-recap");
        this.sizeRecapTxt = this.mainContainer?.querySelector(".hub-content .size-recap p .value");
        this.linkRecapTxt = this.mainContainer?.querySelector(".hub-content .link-recap p .value");
        this.cubeRecapTxt = this.mainContainer?.querySelector(".hub-content .cube-recap p .value");

        this.allSizes = this.mainContainer?.querySelectorAll(".select-size-container div[data-size]");
        this.allLinks = this.mainContainer?.querySelectorAll(".select-link-container div[data-link]");
        this.allCubes = this.mainContainer?.querySelectorAll(".select-cube-container div[data-cube]");

        this.sizeValue = "";
        this.linkValue = "";
        this.finitionValue = "Or";
        this.cubeValue = "";
        this.selectedFinition = "or";

        this.wristCheckbox = this.mainContainer?.querySelector(".wrist-container .text-container input");
        this.wristInput = this.mainContainer?.querySelector(".wrist-container .range-container input");
        this.wristButtonPlus = this.mainContainer?.querySelector(".wrist-container .range-container button[data-name='plus']");;
        this.wristButtonMinus = this.mainContainer?.querySelector(".wrist-container .range-container button[data-name='minus']");;

        this.addToCartContent = this.mainContainer?.querySelector(".add-to-cart-container .add-to-cart-content");
        this.addToCartButton = this.mainContainer?.querySelector(".add-to-cart-container .add-to-cart-content .add-to-cart-button");
        this.customizationBtn = this.mainContainer?.querySelector(".add-to-cart-container .customization-button");
        this.variantJson = "";

        this.floatingCubesContainer = this.mainContainer?.querySelector(".floating-cubes-container");
        this.recapCubesContainer = this.mainContainer?.querySelector(".recap-cubes-container");

        this.selectorCubeOr = this.mainContainer?.querySelector(".select-cube-container .select-finition-content[data-finition='or']");
        this.selectorCubeAr = this.mainContainer?.querySelector(".select-cube-container .select-finition-content[data-finition='ar']");

        this.initEvents();

        this.image?.setAttribute("data-default-url", this.image.src);
    }

    initEvents() {
        this.customizationBtn?.addEventListener("click", () => this.openPersonnalisation());
        this.prevStepBtn?.addEventListener("click", () => this.prevStep());
        this.nextStepBtn?.addEventListener("click", () => this.nextStep());
        this.resetStepBtn?.addEventListener("click", () => this.resetPersonnalisation());
        this.closeStepBtn?.addEventListener("click", () => this.setStep("none"));
        this.sizeStepBtn?.addEventListener("click", () => this.setStep("size"));
        this.linkStepBtn?.addEventListener("click", () => this.setStep("link"));
        this.cubeStepBtn?.addEventListener("click", () => this.setStep("cube"));

        this.addToCartButton?.addEventListener("click", () => this.addToCart());

        this.wristCheckbox?.addEventListener("change", () => this.handleWrist());
        this.wristButtonPlus?.addEventListener("click", () => this.increaseWrist());
        this.wristButtonMinus?.addEventListener("click", () => this.decreaseWrist());

        this.allSizes?.forEach(el => { el.addEventListener("click", () => this.applySize(el)) });
        this.allLinks?.forEach(el => { el.addEventListener("click", () => this.applyLink(el)) });
        this.allCubes?.forEach(el => { el.addEventListener("click", () => this.applyCube(el)) });

        this.selectorCubeOr?.addEventListener("click", () => { this.selectFinition("or") });
        this.selectorCubeAr?.addEventListener("click", () => { this.selectFinition("ar") });

        const cubeObserver = new MutationObserver((mutationsList) => {
            this.curveCube();
        });

        cubeObserver.observe(this.recapCubesContainer, {
            childList: true,   // observe ajout/suppression d'éléments
            subtree: false     // true si tu veux aussi observer les descendants
        });
    }

    setStep(newStep) {
        switch (newStep) {
            case "size":
                !document.body.classList.contains("personnalisation-open") ? document.body.classList.add("personnalisation-open") : null;
                this.mainContainer?.setAttribute("data-step", newStep);
                break;
            case "link":
                !document.body.classList.contains("personnalisation-open") ? document.body.classList.add("personnalisation-open") : null;
                this.mainContainer?.setAttribute("data-step", newStep);
                break;
            case "cube":
                !document.body.classList.contains("personnalisation-open") ? document.body.classList.add("personnalisation-open") : null;
                this.mainContainer?.setAttribute("data-step", newStep);
                break;
            case "none":
                this.closePersonnalisation();
                break;
            default:
                break;
        }
    }

    prevStep() {
        var step = this.mainContainer?.getAttribute("data-step");

        switch (step) {
            case "size":
                this.setStep("none");
                break;
            case "link":
                this.setStep("size");
                break;
            case "cube":
                this.setStep("link");
                break;
            default:
                break;
        }
    }
    nextStep() {
        var step = this.mainContainer?.getAttribute("data-step");

        switch (step) {
            case "size":
                this.setStep("link");
                break;
            case "link":
                this.setStep("cube");
                break;
            case "cube":
                this.setStep("none");
                break;
            default:
                break;
        }
    }

    openPersonnalisation() {
        document.body.classList.add("personnalisation-open");
        this.setStep("size");
    }
    closePersonnalisation() {
        document.body.classList.remove("personnalisation-open");
        this.mainContainer?.setAttribute("data-step", "none");
    }

    applySize(element) {
        var value = element.getAttribute("data-size");

        this.allSizes?.forEach(el => { el.classList.remove("selected") });
        element.classList.add("selected");

        this.sizeValue = value;
        if (this.wristCheckbox.checked) {
            this.sizeValue = this.sizeValue + " - " + parseInt(this.wristInput.value) + "cm";
        }
        this.sizeRecap?.setAttribute("data-recap", this.sizeValue);
        this.sizeRecapTxt.textContent = this.sizeValue;
        this.updateAddToCart();
    }
    applyLink(element) {
        var newSrc = element.getAttribute(`data-img-url-${this.selectedFinition}`);
        var value = element.getAttribute("data-link");

        this.allLinks?.forEach(el => { el.classList.remove("selected") });
        element.classList.add("selected");

        this.image.removeAttribute("srcset");
        this.image.removeAttribute("sizes");
        this.image.removeAttribute("loading");
        this.image.src = "";
        this.image.src = newSrc;

        this.linkValue = value;
        this.linkRecap?.setAttribute("data-recap", this.linkValue);
        this.linkRecapTxt.textContent = this.linkValue;
        this.updateAddToCart();
    }
    applyCube(element) {
        var value = element.getAttribute("data-cube");

        // remove first element if already 12 cubes
        this.activeElements = this.cubeValue.split('/');
        if (this.activeElements?.length >= 12) {
            this.removeSpecificCube(0);
        }

        // select cube step
        element.classList.add("selected");

        // update cubeValue
        if (this.cubeValue != "") {
            this.cubeValue = this.cubeValue + "/" + value;
            // display associated cube
            this.displayAddedCube(value, this.activeElements?.length);
        } else {
            this.cubeValue = value;
            // display associated cube
            this.displayAddedCube(value, 0);
        }

        // update recapTxt
        this.cubeRecap?.setAttribute("data-recap", this.cubeValue);
        this.cubeRecapTxt.textContent = this.formatCubeTxt(this.cubeValue);

        // update product selected variant
        this.updateAddToCart();
    }

    resetCubes() {
        var selectedFloatingCubes = Array.from(
          this.floatingCubesContainer?.querySelectorAll(`img`) ?? []
        );

        selectedFloatingCubes?.forEach((cube, index) => {
            this.removeSpecificCube(0);
        });
    }
    selectFinition(query) {
        const container = this.mainContainer?.querySelector(".select-cube-container .step-content");
        const actualLink = this.mainContainer?.querySelector(".select-link-container div[data-link].selected");

        this.selectedFinition = query;
        this.finitionValue = query === "ar" ? "Argent" : "Or";
        container?.setAttribute("data-finition", query);
        this.applyLink(actualLink);
        this.resetCubes();
        this.updateAddToCart();
    }
    removeSpecificCube(index) {
        // remove cube from cubeValue
        const activeCubes = this.cubeValue.split('/');
        if (index > activeCubes?.length) {
            return;
        }
        this.cubeValue = "";
        activeCubes.forEach((cube, i) => {
            if (i != index) {
                if (this.cubeValue == "") {
                    this.cubeValue = cube;
                } else {
                    this.cubeValue = this.cubeValue + '/' + cube;
                }
            }
        });

        // remove class on cube step
        var selectedCubesStep = Array.from(
          this.mainContainer?.querySelectorAll(".cube-container.selected") ?? []
        );
        var cubeStepToRemove = selectedCubesStep?.[index];
        if (cubeStepToRemove)
            cubeStepToRemove?.classList.remove("selected");

        // update recapTxt
        this.cubeRecap?.setAttribute("data-recap", this.cubeValue);
        this.cubeRecapTxt.textContent = this.formatCubeTxt(this.cubeValue);

        // remove floating cube
        var selectedFloatingCubes = Array.from(
          this.floatingCubesContainer?.querySelectorAll(`img`) ?? []
        );
        var floatingCubeToRemove = selectedFloatingCubes?.[index];
        if (floatingCubeToRemove) {
            this.floatingCubesContainer?.removeChild(floatingCubeToRemove);
        }
        //remove recapCube
        var selectedRecapCubes = Array.from(
          this.recapCubesContainer?.querySelectorAll(`p`) ?? []
        );
        var recapCubeToRemove = selectedRecapCubes?.[index];
        if (recapCubeToRemove) {
            this.recapCubesContainer?.removeChild(recapCubeToRemove);
        }
    }
    removeFloatingCube(element) {
        var selectedFloatingCubes = Array.from(
          this.recapCubesContainer?.querySelectorAll(`p`) ?? []
        );

        selectedFloatingCubes?.forEach((cube, index) => {
            if (cube == element.target) {
                this.removeSpecificCube(index.toString());
            }
        });
    }
    displayAddedCube(dataCube, index) {
        const source = this.mainContainer?.querySelector(`.cube-container[data-cube='${dataCube}'] img`);
        const newElem = document.createElement("img");
        const newRecap = document.createElement("p");

        newElem.src = source?.src;
        newElem.classList.add('floating-cube');
        newElem.setAttribute("data-cube", dataCube);

        newRecap.innerHTML = this.formatCubeTxt(dataCube);
        newRecap.setAttribute("data-cube", dataCube);
        newRecap.addEventListener("click", (e) => this.removeFloatingCube(e));

        this.floatingCubesContainer?.appendChild(newElem);
        this.recapCubesContainer?.appendChild(newRecap);

        this.curveCube();
    }
    curveCube() {
        const cubeImages = this.floatingCubesContainer?.querySelectorAll("img");
        const total = cubeImages?.length;
        if (!total) return;

        const imgWidth = cubeImages[0]?.offsetWidth || 20;

        // --- Paramètres à ajuster ---
        const margin         = 2;            // espace entre cubes en px
        const radius         = imgWidth * 6.66; // courbure : plus grand = arc plus plat
        const rotationFactor = 0.85;          // rotation : 0 = droits, 1 = tangente complète
        // ----------------------------

        const step = imgWidth + margin;
        const center = (total - 1) / 2;

        cubeImages.forEach((img, index) => {
            const theta = (index - center) * step / radius;
            const offset = -radius * (1 - Math.cos(theta));
            const angleRad = theta * rotationFactor;
            const angle = -(angleRad * 180) / Math.PI;

            // Un cube tourné de angleRad occupe imgWidth×|cos(angleRad)| en largeur visuelle.
            // On réduit la marge de chaque côté du vide créé (marge négative autorisée).
            const comp = imgWidth * (1 - Math.abs(Math.cos(angleRad))) / 2;
            const sideMargin = margin / 2 - comp;

            img.style.marginLeft = `${sideMargin}px`;
            img.style.marginRight = `${sideMargin}px`;
            img.style.transform = `translateY(${offset}px) rotate(${angle}deg)`;
        });
    }

    handleWrist() {
        if (!this.wristCheckbox?.checked) {
            return;
        }

        if (parseInt(this.wristInput.value) < 12) {
            this.applySize(this.mainContainer?.querySelector(".select-size-container .select-size-elem[data-size='Petit']"));
        } else if (parseInt(this.wristInput.value) > 15) {
            this.applySize(this.mainContainer?.querySelector(".select-size-container .select-size-elem[data-size='Grand']"));
        } else {
            this.applySize(this.mainContainer?.querySelector(".select-size-container .select-size-elem[data-size='Moyen']"));
        }
    }
    increaseWrist() {
        if (parseInt(this.wristInput.value) < 25) {
            this.wristInput.value = parseInt(this.wristInput.value) + 1;
            if (this.wristCheckbox.checked) {
                this.handleWrist();
            }
        }
    }
    decreaseWrist() {
        if (parseInt(this.wristInput.value) > 5) {
            this.wristInput.value = parseInt(this.wristInput.value) - 1;
            if (this.wristCheckbox.checked) {
                this.handleWrist();
            }
        }
    }


    formatCubeTxt(str) {
        const correspondance = {
            "apostrophe": "'",
            "trait-union": "-",
            "espace": "_",
            "soleil": "☼",
            "coeur": "♡",
            "belier": "♈︎",
            "taureau": "♉︎",
            "gemeaux": "♊︎",
            "gémeaux": "♊︎",
            "cancer": "♋︎",
            "lion": "♌︎",
            "vierge": "♍︎",
            "balance": "♎︎",
            "scorpion": "♏︎",
            "sagittaire": "♐︎",
            "capricorne": "♑︎",
            "verseau": "♒︎",
            "poisson": "♓︎"
        };

        let result = str.replace(/-or|-ar/g, "");
        result = result.replace(/\//g, ' ');

        Object.keys(correspondance).forEach(el => {
            const regex = new RegExp(`\\b${el}\\b`, 'gi');
            result = result.replace(regex, correspondance[el]);
        });

        return result;
    }

    findVariant(size, color, finition) {
        const result = productVariants.find(v =>
            v.option1 === size &&
            v.option2 === color &&
            v.option3 === finition
        );

        this.addToCartButton?.setAttribute("data-id", result.id);
        return result;
    }
    updateAddToCart() {
        if (this.sizeValue != "" && this.linkValue != "" && this.cubeValue != "") {
            this.addToCartContent?.classList.remove("customization");
            this.variantJson = this.findVariant(this.sizeValue, this.linkValue, this.finitionValue);
        } else {
            this.addToCartContent?.classList.add("customization");
        }
    }
    async addToCart() {
        console.log("variante = ", this.variantJson);
        var my_properties = {};
        var variantId = this.variantJson.id;

        my_properties.Cube = this.cubeValue;
        customAddToCart(variantId, 1, my_properties);
    }
    resetPersonnalisation() {
        this.sizeRecap?.setAttribute("data-recap", "none");
        this.linkRecap?.setAttribute("data-recap", "none");
        this.cubeRecap?.setAttribute("data-recap", "none");

        this.mainContainer?.querySelector(".select-size-container .select-size-elem.selected")?.classList.remove("selected");
        this.mainContainer?.querySelector(".select-link-container .select-link-elem.selected")?.classList.remove("selected");
        this.resetCubes();

        this.image.src = "";
        this.image.src = this.image?.getAttribute("data-default-url");

        this.closePersonnalisation();

    }
}

window.addEventListener("load", function() {
    const personnalisationCube = new CustomBraceletCube();
});